import { TranslateHelper } from '@app/_helpers';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BlockHeaderGroup } from '@app/_interfaces/block-header-group';
import { DirectionService } from '@app/_services/direction.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { products } from 'src/fake-server/database/products';
import { BlockProductCarouselService } from './block-realestate-carousel.service';
import { ProductCardNewComponent } from '../../shared/components/product-card-new/product-card-new.component';
import { RealEstateCardComponent } from '../../shared/components/realestate-card/realestate-card.component';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BlockHeaderComponent } from './components/block-header/block-header.component';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-block-realestate-carousel',
    templateUrl: './block-realestate-carousel.component.html',
    styleUrls: ['./block-realestate-carousel.component.scss'],
    providers: [BlockProductCarouselService, TranslateHelper],
    standalone: true,
    imports: [NgClass, BlockHeaderComponent, CarouselModule, OwlPreventClickDirective, NgFor, NgIf, RealEstateCardComponent, ProductCardNewComponent]
})

export class BlockRealEstateCarouselComponent implements OnInit, OnChanges {

    constructor(
        public blockProductCarouselService: BlockProductCarouselService,
        private direction: DirectionService,
        public translate: TranslateService,
        public translateHelper:TranslateHelper
    ) { }
    ngOnInit(): void {
        if(this.products.length) {
            this.products.forEach((group)=>{
                this.headers.push(group.name);
            })

            this.blockProductCarouselService.changeSelectedHeader(0);

            this.currentGroup = this.blockProductCarouselService.selectedHeaderValue;
        }

        if (this.mode == 'product') {
            this.carouselDefaultOptions.items = 3;
            this.layout = 'horizontal';
        }

        this.carouselOptions =  Object.assign({}, this.carouselDefaultOptions, this.carouselOptionsByLayout[this.layout]);
    }

    carouselOptions;

    @Input() name;
    @Input() layout: 'grid-4' | 'grid-4-sm' | 'grid-5' | 'horizontal' | 'custom' = 'custom';
    @Input() rows = 1;
    @Input() products: any[] = [];
    @Input() headers: any[] = [];
    @Input() withSidebar = false;
    @Input() loading = false;
    @Input() icon;
    @Input() mode: 'property' | 'product' = 'property';
    @Input() tag;

    currentGroup;
    //@Output() groupChange: EventEmitter<BlockHeaderGroup> = new EventEmitter();

    columns: any[][] = [];

    carouselDefaultOptions: any = {
        lazyLoad: true,
        items: 2,
        autoWidth: true,
        margin: 14,
        nav: false,
        dots: false,
        loop: true,
        skip_validateItems: true,
        stagePadding: 0,
        rtl: this.direction.isRTL()
    };

    carouselOptionsByLayout: any = {
        'grid-4': {
            responsive: {
                1110: { items: 4, margin: 14 },
                930: { items: 4, margin: 10 },
                690: { items: 3, margin: 10 },
                400: { items: 2, margin: 10 },
                0: { items: 1 }
            }
        },
        'grid-4-sm': {
            responsive: {
                820: { items: 4, margin: 14 },
                640: { items: 3, margin: 10 },
                400: { items: 2, margin: 10 },
                0: { items: 1 }
            }
        },
        'grid-5': {
            responsive: {
                1110: { items: 5, margin: 12 },
                930: { items: 4, margin: 10 },
                690: { items: 3, margin: 10 },
                400: { items: 2, margin: 10 },
                0: { items: 1 }
            }
        },
        'custom': {
            responsive: {
                1210: { items: 2, margin: 26 },
                910: { items: 2, margin: 12 },
                730: { items: 1, margin: 10 },
                590: { items: 1, margin: 10 },
                400: { items: 1, margin: 10 },
                0: { items: 1 }
            }
        },
        'horizontal': {
            items: 3,
            responsive: {
                1110: { items: 3, margin: 14 },
                930: { items: 3, margin: 10 },
                690: { items: 2, margin: 10 },
                0: { items: 1 }
            }
        }
    };

    ngOnChanges(changes: SimpleChanges): void {
        const properties = Object.keys(changes);

        if (properties.includes('products') || properties.includes('row')) {
            this.columns = [];

            if (this.products && this.rows > 0) {
                const products = this.products.slice();

                while (products.length > 0) {
                    this.columns.push(products.splice(0, this.rows));
                }
            }
        }
    }

    groupChange(group): void {
        //this.loading = true;
        this.products = this.products.splice(0, 1)
    }
}
